import { actions, selectors } from 'data'
import { ModalNameType } from 'data/App/types'
import { ActionType, StateType } from 'data/types'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Dispatch } from 'redux'

import ActivateAPIKey from './Activate'
import ActivateFailAPIKey from './ActivateFail'
import CreateApiKey from './Create'
import DeactivateApiKey from './Deactivate'
import Success from './Success'

type OwnPropsType = {
  readonly modalName?: ModalNameType
}

type PropsType = ConnectedProps<typeof connector> & OwnPropsType

class CreateApiKeyContainer extends React.Component<PropsType> {
  hideActivateFailModal = (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    this.props.hideActivateFailModal()
  }

  hideActivateModal = (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    this.props.hideActivateModal()
  }

  handleDeleteSubmit = (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    this.props.handleDeleteSubmit()
  }

  hideDeactivateModal = (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    this.props.hideDeactivateModal()
  }

  hideSuccessModal = (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    this.props.hideSuccessModal()
  }

  render() {
    const { modalName } = this.props

    switch (modalName) {
      case 'API_KEY_ACTIVATE':
        return <ActivateAPIKey hideActivateModal={this.hideActivateModal} />
      case 'API_KEY_ACTIVATE_FAIL':
        return <ActivateFailAPIKey hideActivateFailModal={this.hideActivateFailModal} />
      case 'API_KEY_CREATE':
        return <CreateApiKey onSubmit={() => this.props.handleSubmit()} />
      case 'API_KEY_SUCCESS':
        return (
          <Success
            api={this.props.api}
            hideSuccessModal={this.hideSuccessModal}
            showApiActivationToast={this.props.showApiActivationToast}
          />
        )
      case 'API_KEY_DELETE':
        return (
          <DeactivateApiKey
            handleDeleteSubmit={this.handleDeleteSubmit}
            hideDeactivateModal={this.hideDeactivateModal}
          />
        )
      default:
        return null
    }
  }
}

const mapStateToProps = (state: StateType) => ({
  api: selectors.auth.getApiSettings(state),
  user: selectors.auth.getUser(state)
})

const mapDispatchToProps = (dispatch: Dispatch<ActionType>) => ({
  handleDeleteSubmit: () => {
    dispatch(actions.apiKey.deactivate())
  },
  handleSubmit: () => {
    dispatch(actions.apiKey.create())
  },
  hideActivateFailModal: () => {
    dispatch(actions.app.hideModal('API_KEY_ACTIVATE_FAIL'))
  },
  hideActivateModal: () => {
    dispatch(actions.app.hideModal('API_KEY_ACTIVATE'))
  },
  hideDeactivateModal: () => {
    dispatch(actions.app.hideModal('API_KEY_DELETE'))
  },
  hideSuccessModal: () => {
    dispatch(actions.app.hideModal('API_KEY_SUCCESS'))
  },
  showApiActivationToast: () => {
    dispatch(
      actions.app.addNotif({
        duration: 2,
        title: 'OK_API_KEY_ACTIVATION',
        type: 'success'
      })
    )
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(CreateApiKeyContainer)
